import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { useTheme } from '../contexts/ThemeContext';

const KATEGORI_RENK: Record<string, [string, string]> = {
  ogrenci:  ['#EAF3DE', '#3B6D11'],
  egitmen:  ['#EEEDFE', '#534AB7'],
  ders:     ['#FEF3E2', '#B45309'],
  muhasebe: ['#ECFDF5', '#065F46'],
  kredi:    ['#D1FAE5', '#059669'],
  hakedis:  ['#FEE2E2', '#991B1B'],
  crm:      ['#EDE9FE', '#6D28D9'],
  sube:     ['#E0F2FE', '#0369A1'],
};
const KATEGORI_ETIKET: Record<string, string> = {
  ogrenci:  'Öğrenci',
  egitmen:  'Eğitmen',
  ders:     'Ders',
  muhasebe: 'Muhasebe',
  kredi:    'Kredi',
  hakedis:  'Hakediş',
  crm:      'CRM',
  sube:     'Şube',
};

function tarihFormat(s: string) {
  const d = new Date(s);
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' })
    + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
}

const LIMIT = 50;

export default function Loglar() {
  usePageTitle('Loglar');
  const { isDark } = useTheme();
  const card      = isDark ? '#1a1a1a' : 'white';
  const cardAlt   = isDark ? '#1e1e1e' : '#F9FAFB';
  const cardHover = isDark ? '#252525' : '#FAFAFA';
  const border    = isDark ? '#2a2a2a' : '#E5E7EB';
  const borderSub = isDark ? '#202020' : '#F3F4F6';
  const textPrimary = isDark ? '#e8e8e8' : '#111827';
  const textSec   = isDark ? '#999' : '#6B7280';
  const textMuted = isDark ? '#666' : '#9CA3AF';

  const [satirlar, setSatirlar] = useState<any[]>([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [subeler, setSubeler] = useState<any[]>([]);

  const [filtreler, setFiltreler] = useState({
    kategori: '',
    sube_id: '',
    baslangic: '',
    bitis: '',
  });
  const [sayfa, setSayfa] = useState(0);

  const yukle = useCallback(async (offset: number, f: typeof filtreler) => {
    setYukleniyor(true);
    try {
      const params = new URLSearchParams({ limit: String(LIMIT), offset: String(offset) });
      if (f.kategori) params.set('kategori', f.kategori);
      if (f.sube_id)  params.set('sube_id', f.sube_id);
      if (f.baslangic) params.set('baslangic', f.baslangic);
      if (f.bitis)    params.set('bitis', f.bitis);
      const r = await api.get(`/api/loglar?${params}`);
      setSatirlar(r.data.satirlar);
      setToplam(r.data.toplam);
    } catch (e) { console.error(e); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => {
    api.get('/api/subeler').then(r => setSubeler(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    yukle(sayfa * LIMIT, filtreler);
  }, [sayfa, filtreler, yukle]);

  const filtreDegistir = (k: keyof typeof filtreler, v: string) => {
    setSayfa(0);
    setFiltreler(p => ({ ...p, [k]: v }));
  };

  const toplamSayfa = Math.ceil(toplam / LIMIT);

  return (
    <div style={{ padding: '24px 28px', maxWidth: 1100 }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: textPrimary, margin: 0 }}>Loglar</h1>
        <div style={{ fontSize: 13, color: textMuted, marginTop: 4 }}>Admin işlem geçmişi</div>
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <select
          value={filtreler.kategori}
          onChange={e => filtreDegistir('kategori', e.target.value)}
          style={{ padding: '7px 10px', borderRadius: 8, border: `1px solid ${border}`, fontSize: 13, color: isDark ? '#ccc' : '#374151' }}
        >
          <option value="">Tüm kategoriler</option>
          {Object.entries(KATEGORI_ETIKET).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>

        <select
          value={filtreler.sube_id}
          onChange={e => filtreDegistir('sube_id', e.target.value)}
          style={{ padding: '7px 10px', borderRadius: 8, border: `1px solid ${border}`, fontSize: 13, color: isDark ? '#ccc' : '#374151' }}
        >
          <option value="">Tüm şubeler</option>
          {subeler.map((s: any) => <option key={s.id} value={s.id}>{s.ad}</option>)}
        </select>

        <input type="date" value={filtreler.baslangic}
          onChange={e => filtreDegistir('baslangic', e.target.value)}
          style={{ padding: '7px 10px', borderRadius: 8, border: `1px solid ${border}`, fontSize: 13, color: isDark ? '#ccc' : '#374151' }}
        />
        <input type="date" value={filtreler.bitis}
          onChange={e => filtreDegistir('bitis', e.target.value)}
          style={{ padding: '7px 10px', borderRadius: 8, border: `1px solid ${border}`, fontSize: 13, color: isDark ? '#ccc' : '#374151' }}
        />

        {(filtreler.kategori || filtreler.sube_id || filtreler.baslangic || filtreler.bitis) && (
          <button
            onClick={() => { setSayfa(0); setFiltreler({ kategori: '', sube_id: '', baslangic: '', bitis: '' }); }}
            style={{ padding: '7px 14px', borderRadius: 8, border: `1px solid ${border}`, background: card, fontSize: 13, cursor: 'pointer', color: textSec }}
          >
            Temizle
          </button>
        )}

        <span style={{ marginLeft: 'auto', fontSize: 12, color: textMuted, alignSelf: 'center' }}>
          {toplam} kayıt
        </span>
      </div>

      {/* Tablo */}
      <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, overflow: 'hidden' }}>
        {yukleniyor ? (
          <div style={{ padding: 48, textAlign: 'center', color: textMuted, fontSize: 14 }}>Yükleniyor...</div>
        ) : satirlar.length === 0 ? (
          <div style={{ padding: 48, textAlign: 'center', color: textMuted, fontSize: 14 }}>Kayıt bulunamadı</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: cardAlt, borderBottom: `1px solid ${border}` }}>
                {['Tarih / Saat', 'Admin', 'Şube', 'Kategori', 'İşlem'].map(h => (
                  <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: textSec, letterSpacing: 0.4, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {satirlar.map((log: any) => {
                const [bg, renk] = KATEGORI_RENK[log.kategori] ?? [isDark ? '#2a2a2a' : '#F3F4F6', isDark ? '#ccc' : '#374151'];
                return (
                  <tr key={log.id} style={{ borderBottom: `1px solid ${borderSub}` }}
                    onMouseEnter={e => (e.currentTarget.style.background = cardHover)}
                    onMouseLeave={e => (e.currentTarget.style.background = card)}
                  >
                    <td style={{ padding: '10px 14px', fontSize: 12, color: textSec, whiteSpace: 'nowrap' }}>
                      {tarihFormat(log.olusturuldu)}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: textPrimary }}>{log.kullanici_adi}</div>
                      <div style={{ fontSize: 11, color: textMuted }}>{log.kullanici_email}</div>
                    </td>
                    <td style={{ padding: '10px 14px', fontSize: 12, color: textSec }}>
                      {log.sube_adi || <span style={{ color: textMuted }}>—</span>}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <span style={{ background: isDark ? 'rgba(83,74,183,0.15)' : bg, color: renk, borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 600 }}>
                        {KATEGORI_ETIKET[log.kategori] ?? log.kategori}
                      </span>
                    </td>
                    <td style={{ padding: '10px 14px', fontSize: 13, color: isDark ? '#ccc' : '#374151', maxWidth: 380 }}>
                      {log.detay}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Sayfalama */}
      {toplamSayfa > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 16 }}>
          <button onClick={() => setSayfa(p => Math.max(0, p - 1))} disabled={sayfa === 0}
            style={{ padding: '6px 14px', borderRadius: 7, border: `1px solid ${border}`, background: card, cursor: sayfa === 0 ? 'default' : 'pointer', color: sayfa === 0 ? textMuted : isDark ? '#ccc' : '#374151', fontSize: 13 }}>
            ‹
          </button>
          <span style={{ padding: '6px 14px', fontSize: 13, color: textSec }}>
            {sayfa + 1} / {toplamSayfa}
          </span>
          <button onClick={() => setSayfa(p => Math.min(toplamSayfa - 1, p + 1))} disabled={sayfa >= toplamSayfa - 1}
            style={{ padding: '6px 14px', borderRadius: 7, border: `1px solid ${border}`, background: card, cursor: sayfa >= toplamSayfa - 1 ? 'default' : 'pointer', color: sayfa >= toplamSayfa - 1 ? textMuted : isDark ? '#ccc' : '#374151', fontSize: 13 }}>
            ›
          </button>
        </div>
      )}
    </div>
  );
}
